// SNO selector Jquery plugin
define('commons/runtimes-snos-selector',['jquery', 'commons/element-selector', 'jquery.ui', 'commons/live-search-field'], function($, ElementSelector) {

    var onOk = function() {
        if ($.isFunction(this.settings.onOkClick)) {
            var selectedArray = this.elementSelector.model.selected.asArray();
            var $editMode = this.content.find('input[name=edit_mode]'+this.id+':checked');
            var isSetMode = false;
            if($editMode != undefined && $editMode.val() == "set"){
                isSetMode = true;
            }
            if (selectedArray.length === 0 && !this.defaultVersion.is(':checked')) {
                alert('You must select at least one SO or you must check the "Default for new SOs" checkbox.');
            } else {
                var content = "";
                var hardwareDetails = "";
                if(this.hardwareId != undefined){
                    hardwareDetails += 'for hardware ' + this.hwVersion;
                }else{
                    hardwareDetails += 'for all compatible hardware';
                }
                if(selectedArray.length !== 0){
                    content += 'You have selected ' + selectedArray.length + ' SO(s).\nAre you sure you want to ' + (isSetMode ? 'set' : 'unset') + ' runtime ' + this.version +
                    ' to selected SO(s) ' + hardwareDetails + '?\n\n';
                    if(isSetMode){
                        content += 'Warning: An email will be sent to selected SO.\n\n'
                    }
                }
                if(this.defaultVersion.is(':checked')){
                    content += 'You have ' + (isSetMode ? 'selected' : 'unselected') + ' runtime ' + this.version + ' as version by default for newly created SOs (' + hardwareDetails + ').\n Are you sure?';
                }
                if (confirm(content)) {
                    var params = [
                        selectedArray,
                        this.runtimeId,
                        this.defaultVersion.is(':checked'),
                        this.hardwareId,
                        isSetMode
                    ];
                    this.settings.onOkClick.call(this, params);
                }
            }
        }
    };

    var loadData = function() {
        this.loaded = true;
        this.snoPopupContent.addClass('loading');
        $.ajax({
            type: 'GET',
            url: this.settings.listUrl,
            data: {
                'version': this.version
            },
            dataType: 'html',
            traditional: true,
            success: function(data) {
                pageLoaded.call(this, data);
            },
            context: this
        });
    };

    var pageLoaded = function(data) {
        this.elementSelector.beforeDataLoaded();
        this.snoPopupContent.html(data);
        this.snoPopupContent.removeClass('loading');
        this.elementSelector.onDataLoaded.apply(this.elementSelector);
        return false;
    };
    
    var reinit = function() {
        this.filter.val('');
        this.filter.placeholder=this.settings.filter.placeholder;
        this.defaultVersion.prop('checked', false);
        this.elementSelector.unselectAll();
        this.snoPopup.dialog('option', 'title', this.settings.title);
    };

    var methods = {
        init: function(options) {
            this.settings = {
                dialogOptions: {
                    'autoOpen': false,
                    'resizable': true,
                    'minWidth': 400,
                    'width': '30%',
                    'height': 450,
                    'zindex': 100,
                    'draggable': true,
                    'dialogClass': 'list-selector-dialog',
                    'modal': true
                },
                refresh: false,
                filter: {
                    parameter: 'name',
                    placeholder: 'SO name'
                },
                prefix: '#sno',
                onOkClick: null,
                suffix: false
            };
            $.extend(true, this.settings, options);
            this.version = '';
            this.loaded = false;
            this.name = '';
            this.id = this.settings.suffix ? '_' + this.settings.suffix : '';
            // Create toolbar
            this.snoPopup = this.first().dialog(this.settings.dialogOptions);
            this.snoPopup.dialog('option', 'title', this.settings.title);
            var cont = $(this.snoPopup.dialog('widget').find('.ui-dialog-content'));
            cont.append('<div id="toolbar" class="toolbar top-fixed">' + "<input type='search' placeholder='" + this.settings.filter.placeholder +
                    "' id='idFilter" + this.id + "' />" + ' <input type="checkbox" id="idDefaultVersion"' + this.id +'><label for="idDefaultVersion"' + this.id + '>Default for new SOs</label>'+'<a href="#" class="toolbar-button validate" id="okButton' + this.id + '">Ok</a>');
            cont.append('Edit mode: ');
            cont.append('<input type="radio" id="edit_mode_set' + this.id + '" name="edit_mode' + this.id + '" value="set" checked />');
            cont.append('<span><label for="edit_mode_set' + this.id + '">Set</label></span> ');
            cont.append('<input type="radio" id="edit_mode_unset' + this.id + '" name="edit_mode' + this.id + '" value="unset"/>');
            cont.append('<span><label for="edit_mode_unset' + this.id + '">Unset</label></span>');
            cont.append('</div>');
            
            cont.append('<div id="snocontent' + this.id + '" class="snoListContent"></div>');
            this.elementSelector = new ElementSelector(cont.find('#snocontent' + this.id), {
                suffix: this.id
            });
            cont.find('#okButton' + this.id).click($.proxy(onOk, this));
            cont.find('#idFilter' + this.id).liveSearch({
                searchUrl: this.settings.listUrl,
                data: {
                    'version': this.version
                },
                valueParameter: this.settings.filter.parameter,
                successCallback: $.proxy(pageLoaded, this)
            });
            this.defaultVersion = cont.find('#idDefaultVersion' + this.id);
            this.content = cont;
            this.filter = cont.find('#idFilter' + this.id);
            // get content
            this.snoPopupContent = cont.find('#snocontent' + this.id);
            return this;
        },
        open: function() {
            reinit.call(this);
            this.snoPopup.dialog('open');
            if (!this.loaded || this.settings.refresh) {
                loadData.apply(this);
            }
        },
        close: function() {
            this.snoPopup.dialog('close');
        }
    };

    $.fn.snoSelector = function(method) {
        // Method calling logic
        if (methods[method]) {
            return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
        } else if (typeof method === 'object' || !method) {
            return methods.init.apply(this, arguments);
        } else {
            $.error('Method ' + method + ' does not exist on jQuery.tooltip');
        }
        return this;
    };
});
